export default function PortfolioAnalysisHeader({ data, scenarioCount, simulations, currency }) {
  const metadata = [
    data?.objective && `Objective: ${data.objective}`,
    Number.isFinite(scenarioCount) && `Scenarios: ${scenarioCount}`,
    data?.optimization_mode && `Mode: ${data.optimization_mode}`,
    Number.isFinite(simulations) && `Simulations: ${Number(simulations).toLocaleString()}`,
    currency && `Currency: ${currency}`,
  ].filter(Boolean);

  return <header className="rounded-2xl bg-slate-50 py-7 pr-7 shadow-sm">
    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Portfolio analytical evidence</p>
    <h1 className="mt-2 text-3xl font-semibold text-slate-950">Portfolio Analysis</h1>
    <p className="mt-2 text-slate-600">A guided executive readout: current exposure, Strategic Potential, accepted modeled-decision evidence when available, capital discipline, execution readiness, and the Portfolio Capital Strategy handoff.</p>
    {metadata.length > 0 && <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-500">
      {metadata.map((item) => <span key={item}>{item}</span>)}
    </div>}
  </header>;
}
